import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export interface Slice {
  shouldResetChatSideCar: boolean;
}

const initialState: Slice = { shouldResetChatSideCar: false };

const slice = createSlice({
  name: 'chatSideCar',
  initialState,
  reducers: {
    setShouldResetChatSideCar: (state: Slice, action: PayloadAction<boolean>) => {
      state.shouldResetChatSideCar = action.payload;
    },
  },
});

export function useChatSideCar() {
  return useSelector((state: { chatSideCar: Slice }) => state.chatSideCar);
}

export const selectShouldResetChatSideCar = createSelector(
  (state: { chatSideCar: Slice }) => state.chatSideCar,
  (state) => state.shouldResetChatSideCar
);

export default slice;
